//
// dropzone.js
// Theme module
//

'use strict';

(function() {

  //
  // Variables
  //

  var toggle = document.querySelectorAll('[data-toggle="profile-photo-dropzone"]');


  //
  // Functions
  //

  function globalOptions() {
    Dropzone.autoDiscover = false;
  }

  function init(el) {
    var currentFile = undefined;
    var options = {
      url: $("#profile_photo_upload").data("direct-upload-url"),
      autoProcessQueue: false,
      maxFiles: 1,
      acceptedFiles:"image/png,image/jpeg",
      previewsContainer: el.querySelector('.dz-preview'),
      previewTemplate: el.querySelector('.dz-preview').innerHTML,
      thumbnailHeight: 200,
      thumbnailWidth: 200,
      thumbnailMethod: 'crop',
      init: function() {
        if ($("#server_student_profile_photo").length) {
          var mockFile = { name: "Filename", size: 12345 };
          this.emit("addedfile", mockFile);
          this.emit("thumbnail", mockFile, $("#server_student_profile_photo").attr('src'));
          this.emit("complete", mockFile);
        }
        this.on('addedfile', function(file) {
          uploadFile(file);
          $("#StudentProfilePhotoDropzone").find(".dz-message").removeClass("border-danger");
          $("#StudentProfilePhotoInvalidFeedback").remove();
        });
      }
    }

    // Clear preview
    el.querySelector('.dz-preview').innerHTML = '';

    // Init dropzone
    new Dropzone(el, options);
  }

  const uploadFile = (file) => {
    // your form needs the file_field direct_upload: true, which
    //  provides data-direct-upload-url
    const url = $("#profile_photo_upload").data("direct-upload-url")
    const upload = new ActiveStorage.DirectUpload(file, url)
   
    upload.create((error, blob) => {
      if (error) {
        // Handle the error
      } else {
        // Add an appropriately-named hidden input to the form with a
        //  value of blob.signed_id so that the blob ids will be
        //  transmitted in the normal upload flow
        const hiddenField = document.createElement('input')
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("value", blob.signed_id);
        hiddenField.name = "profile_photo_blob";
        document.querySelector('form').appendChild(hiddenField)
      }
    })
  }

  //
  // Events
  //

  if (typeof Dropzone !== 'undefined' && toggle) {
    globalOptions();

    [].forEach.call(toggle, function(el) {
      init(el);
    });
  }

})();